// components/FeatureCard.js
import React from 'react';

const FeatureCard = ({ feature, onNavigate, onAddToCart }) => {
  const handleCardClick = () => {
    if (feature.id === '06' || feature.id === '08' || feature.id === '09') {
      onNavigate('pronunciation');
    } else if (feature.id === '11') {
      onNavigate('ai-tutor');
    } else {
      onNavigate('vocabulary');
    }
  };

  return (
    <div className="feature-card" onClick={handleCardClick}>
      <div className="feature-number">{feature.id}</div>
      
      {feature.popularity && (
        <div className="popularity-badge">{feature.popularity}</div>
      )}
      
      {feature.gift && (
        <div className="gift-badge">{feature.gift}</div>
      )}
      
      <div className="feature-content">
        <div className="feature-text">
          <h3>{feature.title}</h3>
          {feature.subtitle && <p>{feature.subtitle}</p>}
          
          {feature.syllables && (
            <div className="syllables">
              {feature.syllables.map((syllable, index) => (
                <span key={index} className="syllable">{syllable}</span>
              ))}
            </div>
          )}
          
          {feature.phoneticImages && (
            <div className="phonetic-images">
              {feature.phoneticImages.map((phonetic, index) => (
                <div key={index} className="phonetic-demo">
                  <span className="phonetic-symbol">{phonetic}</span>
                  <div className="mouth-image">👄</div>
                </div>
              ))}
            </div>
          )}
        </div>
        
        <div className="feature-mockup">
          <div className="phone-mockup">
            <div className="phone-screen">
              <div className="app-interface">
                {feature.id === '08' && (
                  <div className="word-interface">
                    <h2>father</h2>
                    <p>/ 'fɑːðər /</p>
                    <p>n. 父亲；祖先</p>
                    <button className="play-btn">🔊</button>
                  </div>
                )}
                {feature.id === '09' && (
                  <div className="assessment-interface">
                    <h2>grandmother</h2>
                    <p>/ 'grænmʌðər /</p>
                    <div className="assessment-score">
                      <p>Are you your grandmother.</p>
                      <div className="score-indicators">
                        <span className="score-dot blue"></span>
                        <span className="score-dot"></span>
                      </div>
                    </div>
                    <button className="record-btn">🎤</button>
                  </div>
                )}
                {(feature.id !== '08' && feature.id !== '09') && (
                  <div className="generic-interface">
                    <div className="app-header-mini">
                      <span>afternoon</span>
                      <div className="progress-dots">
                        <span className="dot active"></span>
                        <span className="dot"></span>
                        <span className="dot"></span>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeatureCard;